<template>
    <div>
        <div style="margin-bottom: 20px;">
            <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
        </div>
        <el-card class="box-card" shadow="hover">
            <div class="scroll-container">
                <!-- 横向滚动内容 -->
                <div class="scroll-content">
                    <div>
                        <div style="font-size: 14px;margin-bottom: 5px;">选择要移动的代理商</div>
                        <el-card class="box-card" shadow="hover">
                            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                                <el-form-item>
                                	<el-input size clearable v-model="formInline.phone" placeholder="请输入代理商账号"></el-input>
                                </el-form-item>
                                <el-form-item>
                                	<el-input size clearable v-model="formInline.agent_no" placeholder="请输入代理商编号"></el-input>
                                </el-form-item>
                                <el-form-item>
                                	<el-input size clearable v-model="formInline.nickname" placeholder="请输入代理商昵称"></el-input>
                                </el-form-item>
                                
                                <el-form-item>
                                	<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
                                		@click="onPreSearch()">查询</el-button>
                                </el-form-item>
                            </el-form>
                        </el-card>
                        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
                            <el-table :data="agentList" size="mini" border style="width: 100%;margin-bottom: 20px;" v-loading="loading" row-key="user_id" :tree-props="{children: 'children'}">
                            	<el-table-column header-align="center" align="left" prop="nickname" label="代理商昵称" min-width="340" style="display: flex;flex-direction: row;">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.level != 1" style="display: inline;margin-right: 2px;">
                                            <el-checkbox  v-model="scope.row.isSected" @change="selChangeClick(scope.row)" :disabled="scope.row.isDisabled"></el-checkbox>
                                        </div>
                                        <span>
                                            {{scope.row.nickname}}(
                                            <span style="color: red;">{{scope.row.level}}代</span>
                                            )
                                        </span>

                                    </template>
                                    
                                </el-table-column>
                                <el-table-column header-align="center" align="center" prop="phone" label="代理商账号" min-width="150"></el-table-column>
                            	<el-table-column header-align="center" align="center" prop="user_money_all" label="总交易量(万元)" min-width="150"></el-table-column>
                            	<el-table-column header-align="center" align="center" prop="merchant_num_all" label="总商户数(个)" min-width="150"></el-table-column>
                                <el-table-column header-align="center" align="center" prop="terminal_stock_num_all" label="终端库存(台)" min-width="150">
                                </el-table-column>
                  
                            </el-table>
                        
                        </el-card>
                    </div>
                    <div style="display: flex;align-items: center;">
                       <div @click="moveClick" class="startText" :style="{'background-color':isMoveBtnState==true?'#81B437':'#AAAAAA'}">开始移动</div> 
                    </div>
                    <div>
                        <div style="font-size: 14px;margin-bottom: 5px;">选择要移至的代理商</div>
                        <el-card class="box-card" shadow="hover">
                            <el-form :inline="true" :model="formInline2" class="demo-form-inline">
                                <el-form-item>
                                	<el-input size clearable v-model="formInline2.phone" placeholder="请输入代理商账号"></el-input>
                                </el-form-item>
                                <el-form-item>
                                	<el-input size clearable v-model="formInline2.agent_no" placeholder="请输入代理商编号"></el-input>
                                </el-form-item>
                                <el-form-item>
                                	<el-input size clearable v-model="formInline2.nickname" placeholder="请输入代理商昵称"></el-input>
                                </el-form-item>
                                
                                <el-form-item>
                                	<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
                                		@click="onPreSearch2()">查询</el-button>
                                </el-form-item>
                            </el-form>
                        </el-card>
                        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
                            <el-table :data="agentList2" size="mini" border style="width: 100%;margin-bottom: 20px;" v-loading="loading2" row-key="user_id" :tree-props="{children: 'children'}">
                            	<el-table-column header-align="center" align="left" prop="nickname" label="代理商昵称" min-width="300" style="display: flex;flex-direction: row;">
                                    <template slot-scope="scope">
                                        <span>
                                            {{scope.row.nickname}}(
                                            <span style="color: red;">{{scope.row.level}}代</span>
                                            )
                                        </span>
                                    
                                    </template>
                                 
                                </el-table-column>
                                <el-table-column header-align="center" align="center" prop="phone" label="代理商账号" min-width="150"></el-table-column>
                                <el-table-column
                                    header-align="center"
                                    align="center"
                                    label="操作"
                                    min-width="120"
                                >
                                    <template slot-scope="scope">
                                        <el-button @click="handleInfo(scope.row)" type="text" size="small">移动至下级</el-button>
                                    </template>
                                </el-table-column>
                                      
                            </el-table>
                        
                        </el-card>
                    </div>
                    
                </div>
            </div>
       
        </el-card>
    </div>
</template>

<script>
    export default {
        data() {
            return {
               formInline: {
                   nickname:'', // 昵称
                   agent_no: '', //代理商编号
                   phone: '', //代理商账号
               }, 
               agentList:[],
               loading:true,
               isMoveState:false,
               isMoveBtnState:false,
               formInline2: {
                   nickname:'', // 昵称
                   agent_no: '', //代理商编号
                   phone: '', //代理商账号
               }, 
               agentList2:[],
               loading2:true,
               moved_user_id:'',
               moved_user_name:''
            }
        },
        mounted() {
        	this.getData()
            this.getData2()
        },
        methods: {
            
            //选择改变
            selChangeClick(item){
                // if (this.isMoveState && this.moved_user_id != item.user_id){
                //     item.isSected = false
                //     this.$confirm('一次仅支持移动一个代理商及所属代理商，您已选择移动代理商!', '温馨提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning',showCancelButton: false,}).then(()=>{
                //        item.isSected = false              
                //     }).catch(err=>{});
                //     return
                // }
                if (item.isSected) {
                    this.moved_user_id = item.user_id
                    this.moved_user_name = item.nickname
                }else {
                   this.moved_user_id = ''
                   this.moved_user_name = ''
                }
                this.chongfuData(item)
                this.getMoveState()
            },
            chongfuData(item){
                if (item.children) {
                    for (let model of item.children) {
                        model.isSected = item.isSected
                        model.isDisabled = item.isSected
                        if (model.children) {
                            this.chongfuData(model)
                        }  
                    }
                }
                
            },
            
            // 改变开始移动状态，是否选择移动代理
            getMoveState(){
                this.isMoveBtnState = false
                this.isMoveState = false
                for (let item of this.agentList) {
                    if (item.isSected) {
                        this.isMoveState = true
                    }
                    item.isDisabled = false
                    if (item.user_id != this.moved_user_id && this.moved_user_id != '') {
                        item.isDisabled = true
                    }
                    this.getMoveStateArr(item)
                }
            },
            getMoveStateArr(item){
                if (item.children) {
                   for (let model of item.children) {
                       if (model.isSected) {
                           this.isMoveState = true
                       }
                       model.isDisabled = false
                       if (model.user_id != this.moved_user_id && this.moved_user_id != '') {
                           model.isDisabled = true
                       }
                       if (model.children) {
                           this.getMoveStateArr(model)
                       }
                       
                   } 
                }
            },
            moveClick(){
                if (!this.isMoveState) {
                    this.$confirm('请先选择要移动的代理商', '温馨提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning',showCancelButton: false,}).then(()=>{
                 
                    }).catch(err=>{});
                    
                    return
                }
                this.isMoveBtnState = true
            },
            // 移线数据
            getData(){
                this.$api.post("user_lane_change/getUserTreeList", this.formInline, res => {
                	let data = res.data;
                    for (let item of data) {
                        this.getDataArr(item)
                    }
                	this.agentList = data;
                	//渲染结束后取消加载
                	this.loading = false;
                }) 
            },
            getData2(){
                this.$api.post("user_lane_change/getUserTreeList", this.formInline2, res => {
                	let data = res.data;
                	this.agentList2 = data;
                	//渲染结束后取消加载
                	this.loading2 = false;
                }) 
            },
            
            getDataArr(item){
                if (item.children) {
                   for (let model of item.children) {
                       model.isSected = false
                       model.isDisabled = false
                       if (model.children) {
                           this.getDataArr(model)
                       }
                       
                   } 
                }
            },
            // 筛选
            onPreSearch() {
                this.isMoveBtnState = false
                this.isMoveState = false
                this.getData()
            },
            onPreSearch2() {
                this.getData2()
            },
            
            handleInfo(row){
                if (!this.isMoveState) {
                    this.$confirm('请先选择要移动的代理商并点亮“开始移动”按钮', '温馨提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning',showCancelButton: false,}).then(()=>{
                 
                    }).catch(err=>{});
                    
                    return
                }
                
                if (!this.isMoveBtnState) {
                    this.$confirm('请先点亮“开始移动”按钮', '温馨提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning',showCancelButton: false,}).then(()=>{
                 
                    }).catch(err=>{});
                    
                    return
                }
                
                if (this.moved_user_id == row.user_id){
                   this.$confirm('移动代理不能和移至代理相同！', '温馨提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning',showCancelButton: false,}).then(()=>{
                                    
                   }).catch(err=>{});
                   
                   return  
                }
                
                this.$api.post("user_lane_change/checkBeforeUserLaneChange", {moved_user_id:this.moved_user_id,moved_user_after_parent_id:row.user_id}, res => {
                	if (res.code == 0) {
                        let obj = res.data
                        if (obj.status == 20000) {
                            this.$confirm(obj.msg, {confirmButtonText: '继续移线',cancelButtonText: '终止移线',type: 'warning'}).then((action)=>{
                                if (action == 'confirm') {
                                    this.realSetLine(row)
                                }           
                            }).catch(err=>{});
                        }else {
                            this.realSetLine(row)
                        }
                	} else {
                        this.$message({type: 'error',message: res.msg,duration: 1500})
                	}
                })
                
                 
                
                
                
                
                
                
                 
            },
            
            realSetLine(row){
                let msg = `确认将【${this.moved_user_name}】移动至【${row.nickname}】下级吗？`
                
                this.$confirm(msg, {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then((action)=>{
                    if (action == 'confirm') {
                        this.$api.post("user_lane_change/createUserLaneChange", {moved_user_id:this.moved_user_id,moved_user_after_parent_id:row.user_id}, res => {
                        	if (res.code == 0) {
                        	    this.$message({
                        	        type: 'success',
                        	        message: res.msg,
                        	        duration: 1500,
                        	        onClose:()=> {
                                        this.getData()
                                        this.getData2()
                 
                        	        }
                        	    })
                        	} else {
                                this.$confirm(res.msg, '温馨提示', {confirmButtonText: '确定',type: 'warning',showCancelButton: false,}).then(()=>{
                                                 
                                }).catch(err=>{});
                        	}
                        })
                    }
                                 
                }).catch(err=>{}); 
                
            }
            
            
            
            
        }
    };
</script>

<style>
    .scroll-container {
      width: 100%;
      height: 100%;
      overflow-x: auto;
      overflow-y: hidden;
    }
     
    .scroll-content {
      width: 1462px; /* 这里的宽度根据需要滚动的内容来设置，这里假设需要滚动两倍的宽度 */
      height: 100%;
      display: flex;
      
    }
    .startText {
        height: 40px;
        width: 100px;
        display: flex;
        justify-content: center;
        align-items: center;margin-top: 130px;background-color: gray;font-size: 15px;color: white;
    }
</style>